// EVENTS.VIEWS.APP.ASSESSMENTS.SINGLE_CATEGORY

export const SINGLE_CATEGORY = {
  PAGE_VISITED: 'single_category-page_visited'
};
